import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function SEOContentSection() {
  return <section className="py-16 bg-white border-t border-gray-200" data-id="element-854" data-mp="tvo7ogvfucwf">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-855" data-mp="tttlz0ccegra">
        <div className="prose prose-lg prose-navy max-w-none" data-id="element-856" data-mp="yo7jp9eh8zz4">
          <h2 className="text-3xl font-bold text-navy mb-6 text-center" data-id="element-857" data-mp="13mivhpoc1kjz">
            Why Choose an Online Degree?
          </h2>

          <p className="text-gray-600 mb-8 text-center" data-id="element-858" data-mp="5zit44b1sd1m">
            Online education has transformed how adults achieve their academic
            and career goals. With flexible scheduling, lower overall costs, and
            the same rigorous curriculum as on-campus programs, earning your
            degree online is a smart investment in your future.
          </p>

          <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-859" data-mp="1rc3hkhfs8xxh">
            <div className="bg-light p-6 rounded-xl border border-gray-100" data-id="element-860" data-mp="1rdoa61ije6sp">
              <h3 className="text-xl font-bold text-navy mb-3 flex items-center" data-id="element-861" data-mp="1w93muq4t5wnj">
                <CheckCircleIcon className="w-5 h-5 text-green-500 mr-2" data-id="element-862" data-mp="wybzd8c7gq94" />
                Flexibility & Convenience
              </h3>
              <p className="text-sm text-gray-600" data-id="element-863" data-mp="ryfs9087oipc">
                Study when and where it works for you. Online programs are
                designed for working professionals, allowing you to balance
                education with career and family responsibilities.
              </p>
            </div>
            <div className="bg-light p-6 rounded-xl border border-gray-100" data-id="element-864" data-mp="e2lwliwg7pu6">
              <h3 className="text-xl font-bold text-navy mb-3 flex items-center" data-id="element-865" data-mp="98q0yn3nqf26">
                <CheckCircleIcon className="w-5 h-5 text-green-500 mr-2" data-id="element-866" data-mp="4braqfn46s99" />
                Career Advancement
              </h3>
              <p className="text-sm text-gray-600" data-id="element-867" data-mp="79rchko2gz0">
                Employers increasingly value online degrees from accredited
                institutions. Gain the skills needed for promotions or career
                changes without leaving your current job.
              </p>
            </div>
          </div>

          <h2 className="text-2xl font-bold text-navy mb-4" data-id="element-868" data-mp="3hs1tevvbtw41">
            How Our Matching Service Works
          </h2>
          <p className="text-gray-600 mb-6" data-id="element-869" data-mp="32varaeu9q6aq">
            Finding the right school can be overwhelming. We simplify the
            process by connecting you with accredited institutions that match
            your specific needs:
          </p>

          <ol className="space-y-4 mb-8 text-gray-600" data-id="element-870" data-mp="3vjyh8npypjum">
            <li className="flex items-start" data-id="element-871" data-mp="4dong6n70qpv">
              <span className="flex items-center justify-center w-8 h-8 rounded-full bg-navy text-white font-bold text-sm mr-4 flex-shrink-0" style={{
              backgroundColor: "#FF9F04"
            }} data-id="element-872" data-mp="4cdkua5hhp0c">
                1
              </span>
              <div data-id="element-873" data-mp="3qqdi2scmujtu">
                <strong className="text-navy block" data-id="element-874" data-mp="id6i32n66y75">
                  Tell us about your goals
                </strong>
                Complete our short form to share your area of interest, current
                education level, and contact information.
              </div>
            </li>
            <li className="flex items-start" data-id="element-875" data-mp="22v8n700t3cw2">
              <span className="flex items-center justify-center w-8 h-8 rounded-full bg-navy text-white font-bold text-sm mr-4 flex-shrink-0" style={{
              backgroundColor: "#FF9F04"
            }} data-id="element-876" data-mp="22u5ucmjxb0di">
                2
              </span>
              <div data-id="element-877" data-mp="2cmv7rmz1aobh">
                <strong className="text-navy block" data-id="element-878" data-mp="1ov69lpzj75mm">
                  Get matched instantly
                </strong>
                Our system filters through hundreds of accredited programs to
                find the ones that align with your criteria.
              </div>
            </li>
            <li className="flex items-start" data-id="element-879" data-mp="1xtjcjlhhx18i">
              <span className="flex items-center justify-center w-8 h-8 rounded-full bg-navy text-white font-bold text-sm mr-4 flex-shrink-0" style={{
              backgroundColor: "#FF9F04"
            }} data-id="element-880" data-mp="1tt7py35koque">
                3
              </span>
              <div data-id="element-881" data-mp="358wcitewznuo">
                <strong className="text-navy block" data-id="element-882" data-mp="35bior6cr2rj8">Compare and enroll</strong>
                Receive information directly from the schools, compare your
                options, and take the next step toward your degree.
              </div>
            </li>
          </ol>
        </div>
      </div>
    </section>;
}